import React, { useContext, useEffect, useMemo, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { EventCss } from "./EventCss";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import PinterestIcon from "@mui/icons-material/Pinterest";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Link, useParams } from "react-router-dom";
import { useAuth } from "modules/auth//hooks";
import {
  useEvent,
  useEventPlayout,
  useEventPlayoutSource
} from "modules/events/hooks";
import {
  HlsVideoPlayer,
  LoaderFullscreen
} from "../../modules/core/components";
import { TimeZoneContext } from "../../contexts/TimeZoneContext";
import {
  computeIsPlayable,
  isPurchasable,
  isUpcoming
} from "../../utils/events/utils";

import "./event.css";
import { Countdown } from "modules/events/components";
import { useCheckout } from "modules/payment/hooks";
import VideoTrimmer from "components/VideoTrimmer/VideoTrimmer";
import videojs from "video.js";

export const EventPage = () => {
  const { uuid } = useParams();
  const { user } = useAuth();

  const { event } = useEvent(uuid);
  const { eventPlayout } = useEventPlayout(uuid);
  const { source, type } = useEventPlayoutSource(eventPlayout);

  const [playerMain, setPlayerMain] = useState<ReturnType<typeof videojs>>();
  const [currentTime, setCurrentTime] = useState(0);
  const [showClipping, setShowClipping] = useState(false);

  const { performCheckout } = useCheckout();
  const timeZone = useContext(TimeZoneContext);

  const { isPlayable, requiresPurchase, showCountdown } = useMemo(() => {
    if (!eventPlayout) return {};

    return {
      isPlayable: computeIsPlayable(eventPlayout, timeZone),
      showCountdown: isUpcoming(eventPlayout),
      requiresPurchase: isPurchasable(eventPlayout, user)
    };
  }, [eventPlayout, user]);

  useEffect(() => {
    if (!event) return;

    document.title = `${event.name} | Staidium`;
  }, [event]);

  const showClippingSection = () => {
    setShowClipping(!showClipping);
  };

  const eventContent = useMemo(() => {
    if (!event) return;
    console.log(requiresPurchase);
    console.log(eventPlayout);
    if (requiresPurchase && eventPlayout?.products && !showCountdown)
      return (
        <div className="event-purchase-container">
          {eventPlayout?.products?.map(({ id, uuid, name, priceFormatted }) => (
            <Button key={id} onClick={() => performCheckout(event.uuid, uuid)}>
              {name} - {priceFormatted}
            </Button>
          ))}
          <p>
            {eventPlayout?.products?.length == 0
              ? "Event is not available"
              : ""}
          </p>
        </div>
      );

    if (requiresPurchase && !eventPlayout?.products && !showCountdown)
      return (
        <div className="event-purchase-container">Event is not available</div>
      );

    if (showCountdown) {
      return (
        <Countdown
          timestamp={new Date(event?.startTime).getTime()}
          name={event?.name}
        />
      );
    }

    if (isPlayable && source) {
      return (
        <HlsVideoPlayer
          src={source}
          type={type}
          setPlayerMain={setPlayerMain}
          setCurrentTime={setCurrentTime}
          currentTime={currentTime}
        />
      );
    }
  }, [event, isPlayable, requiresPurchase, showCountdown, source]);

  if (!event && !source && !isPlayable) return <LoaderFullscreen />;

  return (
    <div style={{ background: "#000" }} className="showEvent">
      <Breadcrumb
        title={""}
        competition={event?.competition?.name}
        date={event?.startTime}
      />
      <Container style={{ padding: "50px 70px" }} className="event-container">
        <div
          className="video-wrap"
          style={{ width: "100%", minHeight: "100%" }}
        >
          {eventContent}
        </div>

        <div
          className="event-details-content"
          style={{ margin: "25px 0 25px" }}
        >
          {source && (
            <Col xs={12} className="controls-container">
              <Button
                className="edit-btn"
                onClick={() => showClippingSection()}
              >
                <img src={"/scissors-cut-fill.svg"} alt="Trim" />
              </Button>
              <span className="edit-text">Edit</span>
            </Col>
          )}

          <div style={{ display: showClipping ? "block" : "none" }}>
            <VideoTrimmer
              playerMain={playerMain}
              source={source}
              title={`${event?.teams[0]?.name} vs. ${event?.teams[1]?.name}`}
            />
          </div>

          <Container>
            <Row>
              <Col md={12} className="event-details-info">
                <ul
                  style={{
                    listStyle: "outside none none",
                    margin: 0,
                    padding: 0
                  }}
                >
                  <li style={EventCss.eventDetailItem}>
                    <span style={EventCss.eventDetailTitle}>
                      {event?.teams[0]?.name} vs. {event?.teams[1]?.name}
                    </span>
                  </li>
                  <li style={EventCss.eventDetailItem}>
                    <span style={EventCss.eventDetailTitle}>Venue: </span>{" "}
                    {event?.competition?.name}
                  </li>
                  <li
                    style={{
                      ...EventCss.eventDetailItem,
                      textTransform: "capitalize"
                    }}
                  >
                    <span
                      style={{
                        ...EventCss.eventDetailTitle
                      }}
                    >
                      Sport:{" "}
                    </span>{" "}
                    {event?.sport?.name === 'icehockey' ? 'Ice Hockey' : event?.sport?.name}
                  </li>
                </ul>
              </Col>

              <Col
                md={12}
                className="like-share-wrap"
                style={EventCss.eventSharePanel}
              >
                <div className="social-share-wrap" style={{ display: "flex" }}>
                  <span style={EventCss.eventDetailTitle}>Share:</span>
                  <div className="social-style-1">
                    <Link
                      style={{
                        ...EventCss.shareIcon,
                        backgroundColor: "#3b5998"
                      }}
                      className="facebook"
                      to={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}
                      target="_blank"
                    >
                      <FacebookIcon></FacebookIcon>
                    </Link>
                    <Link
                      style={{
                        ...EventCss.shareIcon,
                        backgroundColor: "#bd081c"
                      }}
                      className="pinterest"
                      target="_blank"
                      to={`http://pinterest.com/pin/create/button/?url=${window.location.href}`}
                    >
                      <PinterestIcon></PinterestIcon>
                    </Link>
                    <Link
                      style={{
                        ...EventCss.shareIcon,
                        backgroundColor: "#0A66C2"
                      }}
                      className="linkedin"
                      target="_blank"
                      to={`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`}
                    >
                      <LinkedInIcon></LinkedInIcon>
                    </Link>
                    <Link
                      style={{
                        ...EventCss.shareIcon,
                        backgroundColor: "rgb(0, 179, 236)"
                      }}
                      className="twitter"
                      target="_blank"
                      to={`http://twitter.com/share?url=${window.location.href}`}
                    >
                      <TwitterIcon></TwitterIcon>
                    </Link>
                  </div>
                </div>
                <div className="like-dislike-wrap">
                  <Button
                    className="like-dislike-style"
                    style={EventCss.likeDislikeButton}
                  >
                    <ThumbUpIcon />
                  </Button>
                  <Button
                    className="like-dislike-style"
                    style={EventCss.likeDislikeButton}
                  >
                    <ThumbDownIcon />
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>
    </div>
  );
};
